import { IndicatorType } from '../constants/common'
import { getParsedIntegersFromPeriodString } from '../utils/helpers'
import Stochastics from './stofu'

interface Attrs {
  period: string | number
  dPeriod: number
  kPeriod: number
}

class StochasticsSlow extends Stochastics<Attrs> {
  static type = IndicatorType.Stosl
  static label = 'Stochastics SLOW'

  kPeriod = 3

  set(values: Partial<Attrs>) {
    if (typeof values.period === 'string') {
      const [period = 0, dPeriod = 0] = getParsedIntegersFromPeriodString(values.period)
      super.set({ ...values, period, dPeriod, kPeriod: 3 })
    } else {
      super.set(values)
    }
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.period ?? 14,
      required: true,
      min: 1,
      max: 999999,
    }
    const dPeriod = {
      type: 'number',
      label: 'D Period',
      name: 'dPeriod',
      value: this.dPeriod ?? 3,
      required: true,
      min: 1,
      max: 999999,
    }

    return {
      title: this.label,
      inputs: [period, dPeriod],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
        dPeriod: `${dPeriod.label} must be a whole number between ${dPeriod.min} and ${dPeriod.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
      case 'dPeriod':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }

  toString() {
    return `Stochastics SLOW ${this.period},${this.dPeriod}`
  }
}

export default StochasticsSlow
